// extracted by mini-css-extract-plugin
module.exports = {"ui-screen-points":"sm,md,lg,xl","ui-screen-sm-min":"544px","ui-screen-md-min":"768px","ui-screen-lg-min":"1024px","ui-screen-xl-min":"1366px"};